/**
 * Enums for extra charge functionality.
 */

export enum ExtraChargeReason {
  INVOICE_FREQUENCY_EXCEEDED = 'INVOICE_FREQUENCY_EXCEEDED',
  CUSTOM = 'CUSTOM',
}

export enum InvoiceFrequencyPeriodType {
  WEEK = 'WEEK',
  TWO_WEEKS = 'TWO_WEEKS',
  MONTH = 'MONTH',
}

export const ExtraChargeReasonLabels = {
  [ExtraChargeReason.INVOICE_FREQUENCY_EXCEEDED]: 'Invoice Frequency Exceeded',
  [ExtraChargeReason.CUSTOM]: 'Custom',
};

export const InvoiceFrequencyPeriodTypeLabels = {
  [InvoiceFrequencyPeriodType.WEEK]: '1 Week',
  [InvoiceFrequencyPeriodType.TWO_WEEKS]: '2 Weeks',
  [InvoiceFrequencyPeriodType.MONTH]: '1 Month',
};
